export const Divider = () => {
  return <div className="w-full h-px bg-base-border" />;
};
